import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description }) => {
    const siteName = 'SADIDA Network';
    const fullTitle = title ? `${siteName} | ${title}` : siteName;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
        </Helmet>
    )
}

export default SEO;
